import {BiBell} from 'react-icons/bi';
import PromotionIcon from '../Icons/Promotion';
import { cn } from '@/lib/utils';

type MainProps = {
  isNew: boolean;
  isPromotion: boolean;
};

type IsNewProps = {
  newVillaLabel: string;
  promotionTitle?: string;
};

type isPromotionProps = {
  newVillaLabel?: string;
  promotionTitle: string;
};

type Props = MainProps & (IsNewProps | isPromotionProps) & {
  className?: string;
};

export default function VillagePromotionLabel({
  isNew,
  isPromotion,
  className,
  newVillaLabel,
  promotionTitle,
}: Props) {
  return (
    <div className={cn("absolute top-[10px] left-[10px] flex max-w-[calc(100%-70px)] items-center desktop:max-w-[92%] text-xs desktop:text-base text-white bg-black/40 rounded-[23px] z-[1]", {
      className
    })}>
      <div className="flex items-center justify-center w-[45px] min-w-[45px] h-[45px] rounded-[23px] bg-primary leading-[45px]">
        {isNew && <BiBell className="w-5 h-5 text-white" />}
        {isPromotion && (
          <PromotionIcon className="w-4 h-4 fill-current text-white" />
        )}
      </div>
      <span className="desktop:p-[10px_20px_10px_10px] p-2 pr-4 text-center inline-block align-middle uppercase whitespace-nowrap overflow-hidden text-ellipsis">
        {isNew && newVillaLabel}
        {isPromotion && promotionTitle}
      </span>
    </div>
  );
}
